<template>
  <v-container style="min-height: calc(100vh - 80px);" class="my-5">
    <v-row justify="center">
      <v-col cols="12" md="10">
        <v-row>
          <v-col cols="12" md="12">
            <v-tabs centered>
              <v-tab
                class="text-capitalize"
                :to="{ name: 'Detailclass', query: { berita: check.berita } }"
                exact>
                <v-icon left>mdi-text-box-check-outline</v-icon> Pengumuman
              </v-tab>
              <v-tab
                class="text-capitalize"
                :to="{ name: 'Detailclasswork', query: { berita: check.berita } }"
                exact>
                <v-icon left>mdi-folder-text</v-icon> Tugas
              </v-tab>
              <v-tab
                class="text-capitalize"
                :to="{ name: 'Detailclasspeople', query: { berita: check.berita } }"
                exact>
                <v-icon left>mdi-calendar-month</v-icon> Anggota
              </v-tab>
              <v-tab
                v-if="false"
                class="text-capitalize"
                :to="{ name: 'Detailclassgrade', query: { berita: check.berita } }"
                exact>
                <v-icon left>mdi-calendar-month</v-icon> Nilai
              </v-tab>
            </v-tabs>
          </v-col>
          <v-col cols="12" md="12" v-if="alertdata.show">
            <alertsp :alertdata="alertdata" class="mb-0"></alertsp>
          </v-col>
          <v-col cols="12" md="12" v-if="loading.detail" class="text-center">
            <v-progress-circular
              :width="3"
              color="red"
              indeterminate>
            </v-progress-circular>
          </v-col>
          <v-col cols="12" md="12">
            <v-card
              flat
              v-if="!loading.detail && detaildata.length > 0">
              <v-card-text>
                <v-row class="black--text">
                  <v-col cols="12" md="12">
                    <v-row>
                      <v-col cols="12" md="12">
                        <v-menu
                          offset-y
                          bottom
                          right
                          nudge-bottom="10"
                          transition="scale-transition">
                          <template v-slot:activator="{ on, attrs }">
                            <v-btn
                              color="primary"
                              class="text-capitalize"
                              large
                              rounded
                              v-bind="attrs"
                              v-on="on"
                              exact>
                              <v-icon left>mdi-plus</v-icon>
                              Create
                            </v-btn>
                          </template>
                          <v-list>
                            <v-list-item
                              @click="addTugas">
                              <v-list-item-title>
                                <v-icon left>mdi-clipboard-text</v-icon> Assignment
                              </v-list-item-title>
                            </v-list-item>
                            <v-list-item
                              @click="addMateri">
                              <v-list-item-title>
                                <v-icon left>mdi-book</v-icon> Material
                              </v-list-item-title>
                            </v-list-item>
                            <v-list-item
                              @click="reusePost">
                              <v-list-item-title>
                                <v-icon left>mdi-recycle</v-icon> Reuse post
                              </v-list-item-title>
                            </v-list-item>
                          </v-list>
                        </v-menu>
                      </v-col>
                      <v-col cols="12" md="12">
                        <v-card outlined>
                          <v-card-text>
                            <v-expansion-panels>
                              <v-expansion-panel
                                v-for="(post, i) in postlist"
                                :key="i">
                                <v-expansion-panel-header hide-actions>
                                  <span>
                                    <v-icon left>{{ post.type_post === 'materi' ? 'mdi-book' : 'mdi-clipboard-text' }}</v-icon> {{ post.title_post }}
                                  </span>
                                  <v-spacer></v-spacer>
                                  <v-row
                                    align="center"
                                    justify="end">
                                    <span class="text-right caption font-weight-bold" v-if="post.type_post === 'tugas'">
                                      Due {{ post.duedate_post }}
                                    </span>
                                    <span class="text-right caption font-weight-bold" v-if="post.type_post === 'materi'">
                                      Posted {{ post.posted_at_post }}
                                    </span>
                                    <span class="text-right ml-2">
                                      <v-menu
                                        offset-y
                                        bottom
                                        left
                                        nudge-bottom="10"
                                        transition="scale-transition">
                                        <template v-slot:activator="{ on, attrs }">
                                          <v-btn
                                            color="primary"
                                            class="text-capitalize"
                                            icon
                                            v-bind="attrs"
                                            v-on="on"
                                            exact>
                                            <v-icon>mdi-dots-vertical</v-icon>
                                          </v-btn>
                                        </template>
                                        <v-list>
                                          <v-list-item>
                                            <v-list-item-title>Edit</v-list-item-title>
                                          </v-list-item>
                                          <v-list-item>
                                            <v-list-item-title>Delete</v-list-item-title>
                                          </v-list-item>
                                        </v-list>
                                      </v-menu>
                                    </span>
                                  </v-row>
                                </v-expansion-panel-header>
                                <v-expansion-panel-content>
                                  <div class="pa-1">
                                    <div v-html="post.desc_post"></div>
                                  </div>
                                  <v-divider class="py-1"></v-divider>
                                  <v-btn
                                    color="primary"
                                    depressed
                                    tile
                                    text
                                    small
                                    class="px-1 text-capitalize">
                                    {{ post.type_post === 'materi' ? 'Lihat materi' : 'Lihat tugas' }}
                                  </v-btn>
                                </v-expansion-panel-content>
                              </v-expansion-panel>
                            </v-expansion-panels>
                          </v-card-text>
                        </v-card>
                      </v-col>
                    </v-row>
                  </v-col>
                  <v-col cols="12" md="12">
                    <div class="mt-5 text-center">
                      <v-btn
                        class="mr-2 mb-2"
                        fab
                        depressed
                        dark
                        x-small
                        :to="{ name: 'Listclass' }">
                        <v-icon dark>
                          mdi-arrow-left-thick
                        </v-icon>
                      </v-btn>
                      <span class="title">Daftar kelas</span>
                    </div>
                  </v-col>
                </v-row>
              </v-card-text>
            </v-card>
          </v-col>
        </v-row>
      </v-col>
    </v-row>
    <!-- dialog -->
    <v-dialog
      v-model="dmodal.tugas"
      fullscreen
      hide-overlay
      transition="dialog-bottom-transition">
      <v-card>
        <v-toolbar :color="maincolor" dark flat class="px-md-5">
          <v-toolbar-title>
            Assignment
          </v-toolbar-title>
          <v-spacer></v-spacer>
          <v-btn icon @click="closeDmodal('tugas')">
            <v-icon>close</v-icon>
          </v-btn>
        </v-toolbar>
        <v-card-text>
          <v-row justify="center" class="black--text py-5">
            <v-col cols="12" md="8">
              <v-card outlined rounded="lg">
                <v-card-text>
                  <v-form
                    @submit.prevent="submitAddTugas"
                    ref="formaddtugas"
                    v-model="formadd.tugas"
                    lazy-validation>
                    <v-row justify="center" class="black--text">
                      <v-col cols="12" md="12">
                        <v-row>
                          <v-col cols="12" md="12">
                            <v-text-field
                              v-model="addtugas.title_post"
                              :rules="[rules.required]"
                              label="Judul *"
                              name="title_post">
                            </v-text-field>
                          </v-col>
                          <v-col cols="12" md="12">
                            <vue-editor
                              v-model="addtugas.desc_post"
                              placeholder="Deskripsi">
                            </vue-editor>
                          </v-col>
                          <v-col cols="12" md="7">
                            <v-file-input
                              v-model="addtugas.file_post"
                              :rules="rules.files"
                              accept=".pdf"
                              name="fileresume"
                              placeholder="Select file"
                              label="File"
                              show-size>
                            </v-file-input>
                          </v-col>
                          <v-col cols="12" md="5">
                            <date-picker
                              class="mt-4"
                              v-model="addtugas.duedate_post"
                              type="datetime"
                              placeholder="Batas pengumpulan"
                              format="YYYY-MM-DD HH:mm:ss"
                              value-type="format">
                            </date-picker>
                          </v-col>
                        </v-row>
                      </v-col>
                      <v-col cols="12" md="12">
                        <alertsp :alertdata="alertupdate"></alertsp>
                        <v-btn
                          large
                          block
                          :loading="loading.addtugas"
                          :disabled="loading.addtugas || !formadd.tugas"
                          :color="maincolor"
                          class="white--text"
                          type="submit">
                          Post
                        </v-btn>
                      </v-col>
                    </v-row>
                  </v-form>
                </v-card-text>
              </v-card>
            </v-col>
          </v-row>
        </v-card-text>
      </v-card>
    </v-dialog>
    <!-- dialog -->
    <v-dialog
      v-model="dmodal.materi"
      fullscreen
      hide-overlay
      transition="dialog-bottom-transition">
      <v-card>
        <v-toolbar :color="maincolor" dark flat class="px-md-5">
          <v-toolbar-title>
            Material
          </v-toolbar-title>
          <v-spacer></v-spacer>
          <v-btn icon @click="closeDmodal('materi')">
            <v-icon>close</v-icon>
          </v-btn>
        </v-toolbar>
        <v-card-text>
          <v-row justify="center" class="black--text py-5">
            <v-col cols="12" md="8">
              <v-card outlined rounded="lg">
                <v-card-text>
                  <v-form
                    @submit.prevent="submitAddMateri"
                    ref="formaddmateri"
                    v-model="formadd.materi"
                    lazy-validation>
                    <v-row justify="center" class="black--text">
                      <v-col cols="12" md="12">
                        <v-row>
                          <v-col cols="12" md="12">
                            <v-text-field
                              v-model="addmateri.title_post"
                              :rules="[rules.required]"
                              label="Judul *"
                              name="title_post">
                            </v-text-field>
                          </v-col>
                          <v-col cols="12" md="12">
                            <vue-editor
                              v-model="addmateri.desc_post"
                              placeholder="Deskripsi">
                            </vue-editor>
                          </v-col>
                          <v-col cols="12" md="12">
                            <v-file-input
                              v-model="addmateri.file_post"
                              :rules="rules.files"
                              accept=".pdf"
                              name="fileresume"
                              placeholder="Select file"
                              label="File"
                              show-size>
                            </v-file-input>
                          </v-col>
                        </v-row>
                      </v-col>
                      <v-col cols="12" md="12">
                        <alertsp :alertdata="alertupdate"></alertsp>
                        <v-btn
                          large
                          block
                          :loading="loading.addmateri"
                          :disabled="loading.addmateri || !formadd.materi"
                          :color="maincolor"
                          class="white--text"
                          type="submit">
                          Post
                        </v-btn>
                      </v-col>
                    </v-row>
                  </v-form>
                </v-card-text>
              </v-card>
            </v-col>
          </v-row>
        </v-card-text>
      </v-card>
    </v-dialog>
    <!-- dialog -->
    <v-dialog
      v-model="dmodal.reuse"
      fullscreen
      hide-overlay
      transition="dialog-bottom-transition">
      <v-card>
        <v-toolbar :color="maincolor" dark flat class="px-md-5">
          <v-toolbar-title>
            Select post
          </v-toolbar-title>
          <v-spacer></v-spacer>
          <v-btn icon @click="closeDmodal('reuse')">
            <v-icon>close</v-icon>
          </v-btn>
        </v-toolbar>
        <v-card-text class="py-5">
        </v-card-text>
      </v-card>
    </v-dialog>
  </v-container>
</template>

<script>
import qs from 'qs';
import Alertsp from '../../components/Alert.vue';
import { VueEditor } from 'vue2-editor';
import { mapState } from 'vuex';
import DatePicker from 'vue2-datepicker';
import 'vue2-datepicker/index.css';

export default {
  name: 'Detailclasswork',
  data: () => ({
    alertdata: {
      show: false,
      type: 'warning',
      text: '',
    },
    alertupdate: {
      show: false,
      type: 'warning',
      text: '',
    },
    loading: {
      detail: false,
      post: false,
      addtugas: false,
      addmateri: false,
    },
    api: process.env.VUE_APP_API,
    maincolor: process.env.VUE_APP_MAINCOLOR,
    publickey: '123',
    detaildata: [],
    postlist: [],
    panduan: null,
    addtugas: {
      title_post: '',
      desc_post: '',
      duedate_post: null,
      file_post: null,
    },
    addmateri: {
      title_post: '',
      desc_post: '',
      file_post: null,
    },
    paramberita: {
      search: '',
      limit: '',
      offset: '',
    },
    check: {
      berita: '',
    },
    formcheck: {
      valid: false,
    },
    formadd: {
      tugas: false,
    },
    rules: {
      required: (value) => !!value || 'Required.',
      files: [
        (value) => !value || value.size < 5000000 || 'Files less than 5 MB!',
      ],
    },
    hasil: {
      headers: [
        { text: 'Tahun', value: 'tahun_prestasi' },
        { text: 'Peringkat', value: 'juara_prestasi' },
        { text: 'Tingkat', value: 'tingkat_prestasi' },
      ],
      data: [],
    },
    dmodal: {
      tugas: false,
      materi: false,
      reuse: false,
    },
  }),
  watch: {
    '$route.query.berita'(val) {
      if (val) {
        this.check.berita = val;
        this.getClass();
      }
    },
  },
  mounted() {
    if (this.$route.query.berita && this.$route.query.berita !== '') {
      this.check.berita = this.$route.query.berita;
      this.getClass();
    }
  },
  created: () => ({
  }),
  computed: {
    ...mapState([
      'isAuth',
      'tokenpub',
      'tokenscr',
      'userrole',
    ]),
  },
  methods: {
    submitAddMateri() {
      this.alertupdate.show = false;
      if (this.$refs.formaddmateri.validate()) {
        if (this.tokenscr) {
          this.loading.addmateri = true;
          const dataadd = this.addmateri;
          const formData = new FormData();
          // file image
          formData.append('file_post', dataadd.file_post);
          formData.append('title_post', dataadd.title_post);
          formData.append('desc_post', dataadd.desc_post);
          formData.append('id_class', this.check.berita);
          formData.append('type_post', 'materi');
          // send data
          this.axios
            .post(
              this.api + '/api/post/',
              formData,
              {
                headers: {
                  'Content-Type': 'multipart/form-data',
                  'Authorization': 'bearer ' + this.tokenscr,
                },
              },
            )
            .then((res) => {
              // console.log(res);
              if (res.status === 200) {
                const resdata = res.data;
                if (resdata.error === false) {
                  this.$refs.formaddmateri.reset();
                  this.alertupdate.show = true;
                  this.alertupdate.type = 'success';
                  this.alertupdate.text = 'Materi "' + resdata.data + '" berhasil di posting';
                } else {
                  this.alertupdate.show = true;
                  this.alertupdate.type = 'error';
                  this.alertupdate.text = resdata.message;
                }
              } else {
                this.alertupdate.show = true;
                this.alertupdate.type = 'error';
                this.alertupdate.text = 'Internal services error!';
              }
              this.loading.addmateri = false;
            })
            .catch((error) => {
              this.loading.addmateri = false;
              this.alertupdate.show = true;
              this.alertupdate.type = 'error';
              this.alertupdate.text = 'Internal services error!';
            });
        } else {
          this.alertupdate.show = true;
          this.alertupdate.type = 'error';
          this.alertupdate.text = 'Invalid token!';
        }
      }
    },
    submitAddTugas() {
      this.alertupdate.show = false;
      if (this.$refs.formaddtugas.validate()) {
        if (this.tokenscr) {
          this.loading.addtugas = true;
          const dataadd = this.addtugas;
          const formData = new FormData();
          // file image
          formData.append('file_post', dataadd.file_post);
          formData.append('title_post', dataadd.title_post);
          formData.append('desc_post', dataadd.desc_post);
          formData.append('duedate_post', dataadd.duedate_post);
          formData.append('id_class', this.check.berita);
          formData.append('type_post', 'tugas');
          // send data
          this.axios
            .post(
              this.api + '/api/post/',
              formData,
              {
                headers: {
                  'Content-Type': 'multipart/form-data',
                  'Authorization': 'bearer ' + this.tokenscr,
                },
              },
            )
            .then((res) => {
              // console.log(res);
              if (res.status === 200) {
                const resdata = res.data;
                if (resdata.error === false) {
                  this.$refs.formaddtugas.reset();
                  this.alertupdate.show = true;
                  this.alertupdate.type = 'success';
                  this.alertupdate.text = 'Tugas "' + resdata.data + '" berhasil di posting';
                } else {
                  this.alertupdate.show = true;
                  this.alertupdate.type = 'error';
                  this.alertupdate.text = resdata.message;
                }
              } else {
                this.alertupdate.show = true;
                this.alertupdate.type = 'error';
                this.alertupdate.text = 'Internal services error!';
              }
              this.loading.addtugas = false;
            })
            .catch((error) => {
              this.loading.addtugas = false;
              this.alertupdate.show = true;
              this.alertupdate.type = 'error';
              this.alertupdate.text = 'Internal services error!';
            });
        } else {
          this.alertupdate.show = true;
          this.alertupdate.type = 'error';
          this.alertupdate.text = 'Invalid token!';
        }
      }
    },
    closeDmodal(type) {
      if (type === 'tugas') {
        this.dmodal.tugas = false;
      } else if (type === 'materi') {
        this.dmodal.materi = false;
      } else if (type === 'reuse') {
        this.dmodal.reuse = false;
      } else {
        this.dmodal.tugas = false;
      }
    },
    addTugas() {
      this.dmodal.tugas = true;
    },
    addMateri() {
      this.dmodal.materi = true;
    },
    reusePost() {
      this.dmodal.reuse = true;
    },
    getClass() {
      this.loading.detail = true;
      this.alertdata.show = false;
      if (this.check.berita) {
        this.axios
          .get(
            this.api + '/api/kelas/teacher/' + this.check.berita,
            {
              params: this.paramberita,
              headers: {
                Authorization: 'bearer ' + this.tokenscr,
              },
            },
          )
          .then((res) => {
            if (res.status === 200) {
              const resdata = res.data;
              // console.log(resdata);
              if (resdata.error === false) {
                this.detaildata = resdata.data;
                this.getPost();
              } else {
                this.alertdata.show = true;
                this.alertdata.type = 'error';
                this.alertdata.text = resdata.message;
              }
            } else {
              this.alertdata.show = true;
              this.alertdata.type = 'error';
              this.alertdata.text = 'Internal services error!';
            }
            this.loading.detail = false;
          })
          .catch((error) => {
            console.log(error);
            this.loading.detail = false;
            this.alertdata.show = true;
            this.alertdata.type = 'error';
            this.alertdata.text = 'Internal services error!';
          });
      } else {
        this.loading.detail = false;
        this.alertdata.show = true;
        this.alertdata.type = 'error';
        this.alertdata.text = 'Berita tidak ditemukan!';
      }
    },
    getPost() {
      if (this.tokenscr) {
        this.loading.post = true;
        this.axios
          .get(
            this.api + '/api/post/class/' + this.check.berita,
            {
              params: {
              },
              headers: {
                Authorization: 'bearer ' + this.tokenscr,
              },
            },
          )
          .then((res) => {
            if (res.status === 200) {
              const resdata = res.data;
              console.log(resdata);
              if (resdata.error === false) {
                this.postlist = resdata.data;
              }
            }
            this.loading.post = false;
          })
          .catch((error) => {
            console.log(error);
            this.loading.post = false;
          });
      }
    },
  },
  components: {
    Alertsp,
    VueEditor,
    DatePicker,
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
</style>
